module.exports = __webpack_public_path__ + "static/media/claim.5228dcbd.svg";